<template>
  <eco-sidebar-dialog
    destroy-on-close
    title="分配角色门户"
    :visible="dialogVisible"
    width="1040px"
    :before-close="handleClose"
    close-on-click-modal
     append-to-body
  >
  <div style="padding: 20px;height: calc(100% - 40px)">
    <eco-table
       v-if="dialogVisible"
      @load="loadData"
      :data="data"
      :pageResult="pageResult"
      :selection="true"
      :show-export="false"
      :show-custom-column="false"
      :quick-search-props="[{prop: 'name', label: '名称'}]"
      ref="userPortalTable"
    >
      <template v-slot:toolbar>
        <el-button-group>
          <el-button size="small" @click="showPortalDialog()" icon="el-icon-plus">加入门户</el-button>
          <fe-delete-button
            :url="roleDeleteUrl"
            :htTable="$refs.userPortalTable"
            pk="id"
            parameter="layoutIds"
          >删除</fe-delete-button>
        </el-button-group>
      </template>
      <template>
        <eco-table-column type="index" width="50" align="center" label="序号" />
        <eco-table-column prop="id" label="主键" :sortable="true" hidden />
        <eco-table-column
          prop="name"
          label="门户名称"
          width="300"
          :sortable="true"
          :show-overflow-tooltip="true"
        />
        <eco-table-column prop="layoutType" label="布局类型"
                          :filters="[{text:'管理端',value:0},{text:'手机端',value:1},{text:'应用端',value:2}]">
            <template v-slot="{row}">
                <el-tag v-if="row.layoutType==0" type="info">管理端</el-tag>
                <el-tag v-if="row.layoutType==1" type="success">手机端</el-tag>
                <el-tag v-if="row.layoutType==2" type="warning">应用端</el-tag>
            </template>
        </eco-table-column>
      </template>
    </eco-table>
    <eip-portal-dialog ref="eipPortalDialog" @onConfirm="portalDialogOnConfirm" append-to-body />
  </div>
  </eco-sidebar-dialog>

</template>
<script>
import portal from "@/api/portal.js";
import uc from "@/api/uc.js";
import EipPortalDialog from "@/components/dialog/EipPortalDialog.vue";

export default {
  props: {
  },
  components: {
      EipPortalDialog
  },
  computed: {
    roleDeleteUrl: function() {
      return `${window.context.uc}/api/role/v1/roleUser/deleteLayoutRole?code=${this.roleCode}`;
    }
  },
  data() {
    return {
      dialogVisible: false,
      isSubmit: true,
      data: [],
      pageResult: {
        page: 1,
        pageSize: 50,
        total: 0
      },
      roleCode:""
    };
  },
  watch: {
  },
  created() {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    showDialog(roleCode) {
      this.roleCode = roleCode;
      this.dialogVisible = true;
    },
    dialogCancle() {
      this.dialogVisible = false;
    },
    loadData(param, cb) {
      portal.getRoleLayouts(this.roleCode,param)
        .then(response => {
          this.data = response.rows;
          this.pageResult = {
            page: response.page,
            pageSize: response.pageSize,
            total: response.total
          };
        })
        .finally(() => cb());
    },
    showPortalDialog() {
      this.$refs.eipPortalDialog.showDialog();
    },
    portalDialogOnConfirm(selection) {
      if (!selection || selection.length == 0) {
        this.$message.error("请至少选择一个门户");
        return;
      }
      let layoutIds = [];
      for (let portal of selection) {
          layoutIds.push(portal.id);
      }
      let param = {};
      param.codes = this.roleCode;
      param.layoutIds = layoutIds.join(",");
      uc.saveLayoutRole(param).then(data => {
        if (data.state) {
          this.$message({
            message: data.message,
            type: "success",
            showClose: true
          });
          this.$refs.userPortalTable.load();
          return;
        }
        this.$message.error(data.message||"分配门户失败");
      });
    }
  }
};
</script>
<style scoped>
div[aria-invalid="true"] >>> .el-input__inner,
div[aria-invalid="true"] >>> .el-input__inner:focus {
  border-color: #f56c6c;
}
</style>
